/* eslint-disable no-console */
import React, { useState, useLayoutEffect } from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { fetchBusinessClientNames } from "@store/actions/clientIntake";
import lookup from "@methods/lookup";

const AutoCompleteBusinessClient = ({ control, errors, name, onChange, label, disabled, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useLayoutEffect(() => {
    if (!options.length) {
      (async () => {
        const result = await fetchBusinessClientNames(setIsLoading);
        setOptions(result?.sort((a, b) => (a.name && b.name && a.name > b.name ? 1 : -1)));
      })();
    }
  }, []);

  const error = lookup(errors, name);

  return (
    <Controller
      render={(props) => {
        const [inputValue, setInputValue] = useState(props.value?.name);

        const handleChange = (value) => {
          const nextValue = {
            id: value?.id || "",
            name: value?.name || "",
          };

          if (value?.closedBy) {
            nextValue.closedBy = value.closedBy;
          }

          props.onChange(nextValue);
          onChange(value);
        };

        return (
          <Autocomplete
            options={options}
            value={props.value}
            name={props.name}
            inputValue={inputValue}
            style={{ width: "100%" }}
            onInputChange={(_, value) => {
              setInputValue(value);
              // handleChange({ name: value });
            }}
            getOptionLabel={(o) => o?.name || ""}
            renderOption={(o) => o.name}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                error={!!error}
                helperText={error?.message}
                label={isLoading ? "Loading...." : label}
                {...rest}
              />
            )}
            onChange={(e, value) => handleChange(value)}
            disabled={disabled}
          />
        );
      }}
      name={name}
      control={control}
    />
  );
};

AutoCompleteBusinessClient.defaultProps = {
  onChange: () => {},
  disabled: false,
};

export default AutoCompleteBusinessClient;
